import PortableText from "@components/portable-text";
import { Sanity } from "@models/sanity.model";
import { Container } from "./DetailBody.styled";

export interface DetailBodyProps {
  content: Sanity.PortableText;
}

const DetailBody = ({ content }: DetailBodyProps) => {
  return (
    <Container>
      <PortableText value={content} />
    </Container>
  );
};

export default DetailBody;
